import React, { Component, isValidElement } from "react";
import { Grid, Box } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
//import { fetchLedgerDetail } from './API'
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import { withRouter } from "../HOC/withRouter";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import { apiURL, fetchLedgerMaster, fetchReciept } from "./API";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import {
  applyTrimOnObjectValues,
  getRowColData,
  get_YMD_from_SYS,
  isValidItem,
  validatedate_min_max,
  copyRowsAllCols,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import PaymentModeTable from "./PaymentModeTable";
import InvoiceListTable from "./InvoiceListTable";
import LedgerMaster from "./LedgerMaster";
import MoreInfoTextEditor from "./MoreInfoTextEditor";

class ReceiptEntry extends Component {
  state = {
    checkRows: [],
    PendingInvoiceList: [],
    InvoiceDataMeargPendingInvoiceList: [],
    InvoiceDataRemoveDuplicateInvoiceNo: [],
    LedgerGroup: [],
    LedgerGroupList: [],
    // Ledger: [],
    defaultSetting: {},
    columnsinvoice: [
      // { id: "Action", label: "Search", name: "Search" },
      {
        id: "chk_paymentmode",
        label: "",
        type: "Chk",
        // defValue: 0,
        CtrlProps: {
          disablecondition: [
            {
              colID: "enablestatus",
              value: false,
              relationalOperator: "===",
            },
          ],
        },
      },
      // { id: "vac_ledgername", label: "Payment Mode Ledger" },
      { id: "bint_salesacyear", label: "Invoice Year" },
      { id: "vac_invoiceno", label: "Invoice No" },
      { id: "dec_oustandingamount", label: "Outstanding Amount" },
      {
        id: "dec_amount",
        label: "Paid Amount",
        type: "CtTxtAmt",
        // defValue: 0,
        CtrlProps: {
          defValue: "",
          width: 100,
          maxLength: 10,
          disablecondition: [
            {
              colID: "enablestatus",
              value: false,
              relationalOperator: "===",
            },
          ],
        },
      },
      //   {
      //     id: "vac_chequeno",
      //     label: "Cheque No",
      //     type: "CtTxtNum",
      //     CtrlProps: { value: "", width: 100, maxLength: 6 },
      //   },
      //   {
      //     id: "vac_referenceno",
      //     label: "Reference No",
      //     type: "CtTxtNum",
      //     CtrlProps: { value: "", width: 100, maxLength: 100 },
      //   },
      //   {
      //     id: "dat_transactiondate",
      //     label: "Transaction Date",
      //     type: "CtDtp",
      //     CtrlProps: { value: "", maxLength: 20 },
      //   },
      //   {
      //     id: "vac_remark",
      //     label: "Remark",
      //     type: "CtMultiLineText",
      //     CtrlProps: { value: "", width: 100, maxLength: 1000 },
      //   },
    ],
    rowsinvoice: [],
    columns: [
      // { id: "Action", label: "Search", name: "Search" },
      {
        id: "chk_paymentmode",
        label: "",
        type: "Chk",
        // defValue: 0,
        CtrlProps: { behaviour: "radio" },
      },
      { id: "vac_ledgername", label: "Payment Mode Ledger" },
      {
        id: "dec_amount",
        label: "Payment Mode Amount",
        type: "CtTxtAmt",
        // defValue: 0,
        CtrlProps: { defValue: "", width: 100, maxLength: 10 },
      },
      {
        id: "vac_chequeno",
        label: "Cheque No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 6 },
      },
      {
        id: "vac_referenceno",
        label: "Reference No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 100 },
      },
      {
        id: "dat_transactiondate",
        label: "Transaction Date",
        type: "CtDtp",
        CtrlProps: { value: "", maxLength: 20 },
      },
      {
        id: "vac_remark",
        label: "Remark",
        type: "CtMultiLineText",
        CtrlProps: { value: "", width: 100, maxLength: 1000 },
      },
    ],
    // rows: [{ dec_amount: 0}],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "RecieptEntry:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "RecieptEntry:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Receipt == "R" ||
          this.props.userPrivilege.Receipt == "W",
      },
    ],
    keyColumn: [
      "bint_acid",
      "vac_groupname",
      "vac_ledgername",
      "dec_amount",
      "vac_chequeno",
      "vac_referenceno",
      "dat_transactiondate",
      "vac_remark",
    ],
    formData: {
      edit_incomesrno: "",
      txtRecieptNo: "",
      dtpDate: get_YMD_from_SYS(new Date()),
      cmbLedgerGroup: "Customer",
      cmbLedger: this.props.cmbCustomer || "",
      txtAmount: this.props.txtAdvPayment || "",
      txtRemark: "",
      dec_amount: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
    searchData: {
      invoiceno: "",
      invoiceyear: "",
      outstandingamt: "",
      paidamount: "",
    },
    disableReceiptAmt: false,
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    PaymentData: [],
    PaymentmodeListCols: [
      "bint_acid",
      "bint_ledgercode",
      "bint_ledgeridsrno",
      "dec_opbalance",
      "vac_backgroundprocess",
      "vac_company",
      "vac_firmname",
      "vac_groupheader",
      "vac_groupname",
      "vac_gstno",
      "vac_ledgername",
    ],
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    // document.title = "RiTe Account : Receipt Entry";
    this.props.setActiveMenu("ReceiptEntry");
    this.ShortCut();
    this.setSearchColumns();
    this.props.verifyUserID(() => {
      this.getInfo(true);
    });
  }
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };
  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickSave: this.SaveReciept,
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: this.onDeleteClick,
        handleOnclickPrint: this.PrintReciept,
        handleOnClickRemark: () => {
          this.openRichTextBox(
            "Remark",
            "Remark",
            this.state.formData.txtRemark
          );
        },
      }),
    });
  };

  //#endregion Component

  //#region handle
  CustomerOpCall = () => {
    if (!this.notifyProcessingCalled) {
      // console.log("CustomerOpCall call");
      this.notifyProcessingCalled = true;
      this.props.notifyProcessing();
      const reqData = {
        Op: "PendingInvoiceList",
        bint_acid: localStorage.getItem("acid"),
        vac_customer: this.state.formData.cmbLedger,
      };
      fetchReciept(reqData)
        .then((res) => {
          this.props.closeUpdateProcessing(res.data.msgType, res.data.message);
          let PendingInvoiceList = [];
          let EditReceiptData = [];
          let editdecamount = "";
          // console.log("res.data.PendingInvoiceList", res.data.PendingInvoiceList);
          if (
            res.data.PendingInvoiceList &&
            res.data.PendingInvoiceList.length > 0
          ) {
            PendingInvoiceList = res.data.PendingInvoiceList;
            EditReceiptData = this.props.EditReceiptData;
            if (this.props.EditReceiptData) {
              editdecamount = Number(EditReceiptData[0].dec_amount)
                ? Number(EditReceiptData[0].dec_amount)
                : "";
            }
            this.setState({
              formData: {
                ...this.state.formData,
                txtAmount: this.props.txtAdvPayment || editdecamount,
              },
              PendingInvoiceList,
            });
          } else {
            this.setState({ PendingInvoiceList });
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in CustomerOpCall.", error);
        })
        .finally(() => {
          this.notifyProcessingCalled = false;
        });
    }
  };

  handleOnChange = (e) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        if (e.target.name === "cmbLedger") {
          // console.log("e.target.value", e.target.value);
          // this.state.LedgerGroup.map((row) => {
          //   if (row.vac_ledgername === e.target.value) {
          //     this.CustomerOpCall();
          //   } else {
          //     this.setState({ PendingInvoiceList: [] });
          //   }
          // });
          if (this.validateLedger()) {
            // alert("CustomerOpCall for Customer Invoice List");
            this.CustomerOpCall();
          } else {
            this.setState({ PendingInvoiceList: [], txtAmount: "" });
          }
        }

        /* if (e.target.name === "txtAmount") {
          let vac_groupname = this.state.formData.cmbLedgerGroup;
          let vac_ledgername = this.state.formData.cmbLedger;
          let rows = this.state.rows.map((row, index) => {
            if (
              row.chk_paymentmode == true
              // row.vac_ledgername === this.state.defaultSetting.vac_ledgername
            ) {
              row.dec_amount = this.state.formData.txtAmount;
            }
            return row;
          });
          this.setState({ rows });
          // console.log("vac_ledgername", vac_ledgername);
        } */
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  /* handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {
      if (colID == "chk_paymentmode") {
        this.setPaymentModeTableDataForSave()
      }
    });
  }; */

  handleARDonActionClick = (values) => {
    // console.log("values", values);
    const bint_srno = values[0].value,
      cmbCompanyName = values[1].value,
      txtLegderName = values[2].value,
      cmbLedgerType = values[3].value,
      txtLegderCode = values[4].value,
      txtOpeningBalance = values[5].value,
      cmbBalanceSheet = values[6].value,
      chktrading = values[7].value,
      chkprofitloss = values[8].value,
      actionName = values[0].actionName;
    if (actionName === "Edit") {
      this.setState({
        formData: {
          ...this.state.formData,
          bint_srno,
          cmbCompanyName,
          txtLegderName,
          cmbLedgerType,
          txtLegderCode,
          txtOpeningBalance,
          cmbBalanceSheet,
          chktrading,
          chkprofitloss,
        },
      });
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete  : " + bint_srno + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteLedgerDetail(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      let rows = this.state.rows.filter((row) => {
        if (
          row.bint_srno !== bint_srno &&
          row.vac_CompanyName !== cmbCompanyName &&
          row.vac_LegderName !== txtLegderName &&
          row.vac_LegderType !== cmbLedgerType &&
          row.int_LegderCode !== txtLegderCode &&
          row.dec_OpeningBalance !== txtOpeningBalance &&
          row.vac_BalanceSheet !== cmbBalanceSheet &&
          row.vac_trading !== chktrading &&
          row.vac_profitloss !== chkprofitloss
        )
          return row;
      });
      const rowsCount = rows.length;
      this.setState({ rows, rowsCount });
    }
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchInputChangeTrim = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value.trim(),
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.invoiceno.length === 0 ||
            (row["invoiceno"] &&
              row["invoiceno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.invoiceno.toLowerCase()))) &&
          (this.state.searchData.invoiceyear.length === 0 ||
            (row["invoiceyear"] &&
              row["invoiceyear"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.invoiceyear.toLowerCase()))) &&
          (this.state.searchData.outstandingamt.length === 0 ||
            (row["outstandingamt"] &&
              row["outstandingamt"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.outstandingamt.toLowerCase()
                ))) &&
          (this.state.searchData.paidamount.length === 0 ||
            (row["paidamount"] &&
              row["paidamount"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.paidamount.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };
  //#endregion handle

  //#region function
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  // ShortCut = () => {
  //   this.setState({
  //     removeKeyboardShortCuts: setKeyboardShortcuts(
  //       this.SaveReciept,
  //       this.clearInfo,
  //       () => {
  //         this.onDeleteClick();
  //       }
  //     ),
  //   });
  // };

  navigateTo = (link) => {
    this.props.navigate("/" + link);
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["cmbLedgerGroup"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateLedgerGroup = () => {
    let result = false;
    if (this.state.formData.cmbLedgerGroup.length > 0) {
      this.state.LedgerGroupList.map((row) => {
        if (row.vac_groupname === this.state.formData.cmbLedgerGroup) {
          result = true;
        }
      });
    }
    return result;
  };

  // CheckLedgerisexist = () => {
  //   let result = false;
  //   this.state.LedgerGroup.map((row) => {
  //     if (row.vac_ledgername === e.target.value) {
  //       result = true;
  //     } else {
  //       result = false;
  //     }
  //   });
  //   return result;
  // };

  validateLedger = () => {
    let result = false;
    if (this.state.formData.cmbLedger.length > 0) {
      this.state.LedgerGroup.map((row) => {
        if (row.vac_ledgername === this.state.formData.cmbLedger) {
          result = true;
        }
      });
    }
    return result;
  };

  validateReciept = () => {
    let result = false;
    if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpDate,
        "dtpDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return false;
    } else if (
      this.state.formData.cmbLedgerGroup.length > 0 &&
      this.validateLedgerGroup() === false
    ) {
      this.props.toastErrorMsg("Select valid Ledger Group", "cmbLedgerGroup");
    } else if (this.state.formData.cmbLedger.length <= 0) {
      this.props.toastErrorMsg("Select Ledger Name", "cmbLedger");
    } else if (this.validateLedger() === false) {
      this.props.toastErrorMsg("Select valid Ledger Name", "cmbLedger");
    } else if (this.state.formData.txtAmount.length <= 0) {
      this.props.toastErrorMsg("Enter Amount", "txtAmount");
    } else if (this.state.rows.length === 0) {
      this.props.toastErrorMsg("No Payment details found");
    } else {
      result = true;
    }
    return result;
  };

  validatePaymentModeAmount = () => {
    let result = false,
      dec_amount = 0;
    if (this.state.rows.length > 0) {
      this.state.rows.map((row, index) => {
        if (row.dec_amount !== null && row.dec_amount !== undefined) {
          dec_amount += Number(row.dec_amount);
        }
      });
      if (dec_amount === Number(this.state.formData.txtAmount)) {
        result = true;
      } else if (dec_amount === 0) {
        this.props.toastErrorMsg("Enter Payment Mode Amount", "txtAmount");
      } else {
        this.props.toastErrorMsg(
          "Receipt Amount must be same as Total of Payment Mode Amount",
          "txtAmount"
        );
      }
    } else {
      result = true;
    }
    return result;
  };

  clearInfo = () => {
    console.log("call 648");

    const edit_incomesrno = "",
      txtRecieptNo = "",
      dtpDate = get_YMD_from_SYS(new Date()),
      cmbLedgerGroup = "Customer",
      cmbLedger = "",
      txtAmount = "",
      txtRemark = "";
    const PaymentData = this.state.rows.map((item) => ({
      ...item,
      dec_amount: "",
      vac_chequeno: "",
      vac_referenceno: "",
      dat_transactiondate: "",
      vac_remark: "",
    }));
    // const PaymentData = [];
    this.setState(
      {
        formData: {
          ...this.state.formData,
          edit_incomesrno,
          txtRecieptNo,
          dtpDate,
          cmbLedgerGroup,
          cmbLedger,
          txtAmount,
          txtRemark,
        },
        rows: PaymentData,
        PaymentData: [],
        InvoiceData: [],
        PendingInvoiceList: [],
        InvoiceDataMeargPendingInvoiceList: [],
        InvoiceDataRemoveDuplicateInvoiceNo: [],
        rowsPaymentMode: copyRowsAllCols(
          this.state.LedgerGroup,
          this.state.PaymentmodeListCols
        ),
      },
      () => {
        document.getElementById("dtpDate").focus();
      }
    );
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "invoiceno",
        label: "Invoice No",
        value: this.state.searchData.invoiceno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "invoiceyear",
        label: "Invoice Year",
        value: this.state.searchData.invoiceyear,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "outstandingamt",
        label: "Outstanding Amount",
        value: this.state.searchData.outstandingamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "paidamount",
        label: "Paid Amount",
        value: this.state.searchData.paidamount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  validatePaidAmtGraterOutstandingAmt = () => {
    let result = false;
    // console.log("result", result);
    // console.log("this.state.checkRows", this.state.checkRows.length);
    if (this.state.checkRows && this.state.checkRows.length > 0) {
      this.state.checkRows.map((row) => {
        // console.log("row", row);
        if (Number(row.dec_amount) > Number(row.dec_oustandingamount)) {
          this.props.toastErrorMsg(
            "In Invoice No : '" +
              row.vac_invoiceno +
              "' You Can Enter Paid Amount Upto " +
              row.dec_oustandingamount
          );
          return result;
        } else {
          result = true;
        }
      });
    } else {
      result = true;
    }
    // console.log("result 2 ", result);
    return result;
  };

  SaveReciept = (bolreceiptprint = false) => {
    console.log("this.state.formData.dtpDate", this.state.formData.dtpDate);
    // this.validatePaidAmtGraterOutstandingAmt();
    if (
      this.validateReciept() &&
      this.validatePaymentModeAmount() &&
      this.validatePaidAmtGraterOutstandingAmt()
    ) {
      // console.log("call save button");
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        // console.log("this.state.checkRows", this.state.checkRows);
        let CheckedInvoiceList = this.state.checkRows.map((row) => {
          // console.log("row", row);
          // console.log("row.dec_amount", row.dec_amount);
          // if (Number(row.dec_amount) && Number(row.dec_amount) > 0) {
          return {
            ...row,
            dec_paidamount: row.dec_amount,
            bint_itemsrno: row.bint_itemsrno ? row.bint_itemsrno : 0,
          };
          // }
        });
        // console.log("CheckedInvoiceList", CheckedInvoiceList);
        const reqData = {
          Op: "SaveIncome_Payment",
          // bolreceiptprint: false,
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          vac_company: localStorage.getItem("CompanyName"),
          bint_incomesrno: this.state.formData.txtRecieptNo,
          dat_date: this.state.formData.dtpDate,
          vac_groupname: this.state.formData.cmbLedgerGroup,
          vac_ledgername: this.state.formData.cmbLedger,
          dec_amount: this.state.formData.txtAmount,
          vac_remark: this.state.formData.txtRemark,
          bint_vouno: 0,
          PaymentData: this.state.rows,
          dat_fromdate: "",
          dat_todate: "",
          CheckedInvoiceList,
        };
        // console.log("reqdata", reqData);
        fetchReciept(reqData)
          .then((res) => {
            // console.log("reqData", reqData);
            this.props.updateProcessing(res.data.msgType, res.data.message);
            // console.log("res.data.msgType", res.data.msgType);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = 0;
              if (res.data.IncomeList && res.data.IncomeList.length > 0) {
                rows = res.data.IncomeList;
                rowsCount = rows.length;
              }
              let bint_incomesrno = 0;
              if (
                res.data.bint_incomesrno &&
                Number(res.data.bint_incomesrno) > 0
              ) {
                bint_incomesrno = res.data.bint_incomesrno;
              }
              if (bolreceiptprint) {
                this.openReceiptPrint(bint_incomesrno);
              }
              this.getInfo();
              this.clearInfo();
              this.props.refreshReceiptList(rows, rowsCount);

              // this.setState(() => {
              //   if (bolreceiptprint) {
              //     this.openReceiptPrint();
              //   }
              // this.props.refreshReceiptList(rows, rowsCount);
              //   this.clearInfo();
              // });
            }
          })

          .catch((error) => {
            console.log("Unknown error occurred in SaveReciept.", error);
          });
      });
    }
  };

  PrintReciept = () => {
    this.props.toastErrorMsg("Development pending");
  };

  getInfo = (useProps = false) => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "IncomeData",
        bint_acyear: localStorage.getItem("ACY"),
        bint_acid: localStorage.getItem("acid"),
        edit_incomesrno:
          useProps && this.props.bint_incomesrno
            ? this.props.bint_incomesrno
            : 0,
      };
      fetchReciept(reqData)
        .then((res) => {
          dataLoadStatus = true;
          // console.log("InvoiceData", res.data.InvoiceData);
          let InvoiceData = [];
          let LedgerGroup = [];
          let LedgerGroupList = [];
          let defaultSetting = res.data.DefaultEntrySettingList[0];
          let rows = [],
            PaymentLedgerNameList = [],
            rowsCount = rows.length,
            PaymentData = [];
          if (res.data.LedgerNameList && res.data.LedgerNameList.length > 0) {
            LedgerGroup = res.data.LedgerNameList;
            LedgerGroupList = getRowColData(LedgerGroup, "vac_groupname");
          }
          if (
            res.data.PaymentLedgerNameList &&
            res.data.PaymentLedgerNameList.length > 0
          ) {
            rows = res.data.PaymentLedgerNameList;
            rowsCount = rows.length;
            PaymentLedgerNameList = res.data.PaymentLedgerNameList;
          }
          if (res.data.PaymentData && res.data.PaymentData.length > 0) {
            PaymentData = res.data.PaymentData;
          }
          if (res.data.InvoiceData && res.data.InvoiceData.length > 0) {
            InvoiceData = res.data.InvoiceData;
            this.state.disableReceiptAmt = true;
          }
          /* let retrows = rows.map((row, index) => {
            if (
              row.vac_ledgername === defaultSetting.vac_ledgername
            ) {
              row.chk_paymentmode = true;
            }
            return row;
          }); */
          this.setState(
            {
              dataLoadStatus,
              LedgerGroup,
              LedgerGroupList,
              rows,
              rowsCount,
              defaultSetting,
              PaymentData,
              InvoiceData,
            },
            () => {
              if (useProps) {
                this.onEditReceiptEntry(res.data.PaymentData, rows);
              }
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in getInfo.", error);
        });
    });
    document.getElementById("dtpDate").focus();
  };

  onEditReceiptEntry = (PaymentData, rows) => {
    if (this.props.bint_incomesrno && Number(this.props.bint_incomesrno) > 0) {
      let rowsCount = 0;
      if (this.props.EditReceiptData && this.props.EditReceiptData.length > 0) {
        let EditReceiptData = this.props.EditReceiptData;
        console.log("EditReceiptData", EditReceiptData);
        if (PaymentData && PaymentData.length > 0) {
          PaymentData.map((odd) => {
            let isFound = 0;
            rows.map((rod) => {
              if (rod.vac_ledgername === odd.vac_ledgername) {
                // rod.vac_value = odd.vac_value;
                rod.dec_amount = odd.dec_amount;
                rod.vac_chequeno = odd.vac_chequeno;
                rod.vac_referenceno = odd.vac_referenceno;
                rod.dat_transactiondate = odd.dat_transactiondate;
                rod.vac_remark = odd.vac_remark;
                // rod.vac_groupname = odd.vac_groupname;
                isFound++;
              }
            });
            if (isFound === 0) {
              rows.push({
                vac_ledgername: odd.vac_ledgername,
                dec_amount: odd.dec_amount,
                vac_chequeno: odd.vac_chequeno,
                vac_referenceno: odd.vac_referenceno,
                dat_transactiondate: odd.dat_transactiondate,
                vac_remark: odd.vac_remark,
                // vac_groupname: odd.vac_groupname,
                // bint_displayorderno: rowsPaymentMode.length + 1,
              });
            }
          });
          rowsCount = rows.length;
        }
        /* let amtCount = 0, amtIndex = 0
        rows = rows.map((row, index) => {
          if (Number(row.dec_amount) > 0) {
            amtIndex = index
            amtCount++
          }
          return row
        });
        if (amtCount > 0) {
          rows = rows.map((row, index) => {
            row.chk_paymentmode = false;
            return row;
          });
          if (amtCount === 1)
            rows[amtIndex].chk_paymentmode = true
        } */

        this.setState(
          {
            rows,
            rowsCount,
            formData: {
              ...this.state.formData,
              edit_incomesrno: EditReceiptData[0].bint_incomesrno,
              txtRecieptNo: EditReceiptData[0].bint_incomesrno,
              dtpDate: EditReceiptData[0].dat_date,
              cmbLedgerGroup: EditReceiptData[0].vac_groupname,
              cmbLedger: EditReceiptData[0].vac_ledgername,
              txtAmount: Number(EditReceiptData[0].dec_amount),
              txtRemark: EditReceiptData[0].vac_remark,
            },
          },
          () => {
            document.getElementById("dtpDate").focus();
          }
        );
      }
    }
  };

  onDeleteClick = () => {
    if (this.state.formData.edit_incomesrno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete this Receipt No. : " +
              this.state.formData.txtRecieptNo +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteReceipt(
                this.state.formData.edit_incomesrno,
                this.props.dtpFromDate,
                this.props.dtpToDate
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  openReceiptPrint = (bint_incomesrno) => {
    this.props.notifyProcessing();
    let reqData = [
      { name: "Op", value: "ReceiptPrint" },
      { name: "bint_acyear", value: localStorage.getItem("ACY") },
      { name: "bint_acid", value: localStorage.getItem("acid") },
      { name: "bint_incomesrno", value: bint_incomesrno },
      { name: "bolPrintSingatureStamp", value: 1 },
    ];
    // console.log("reqData", reqData);

    // Create a query string from the request data
    let queryString = reqData
      .map(
        (data) =>
          encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
      )
      .join("&");

    // Set the URL of the popup window
    let popupURL = apiURL + "incomeentrydetail.php?" + queryString;

    // Open the popup window
    window.open(
      popupURL,
      "ReceiptList",
      "width=" +
        window.screen.availWidth +
        ",height=" +
        window.screen.availHeight
    );

    this.props.updateProcessing("success", "PDF Open in popup.");
  };

  deleteReceipt = (edit_incomesrno, dtpFromDate, dtpToDate) => {
    if (edit_incomesrno > 0) {
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "DeleteIncome",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          edit_incomesrno: edit_incomesrno,
          dat_fromdate: dtpFromDate,
          dat_todate: dtpToDate,
        };
        // console.log("reqData", reqData);
        fetchReciept(reqData)
          .then((res) => {
            // let rows = [],
            //   rowsCount = 0,
            //   IncomeList = [];

            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = 0,
                IncomeList = [];
              if (res.data.IncomeList && res.data.IncomeList.length > 0) {
                rows = res.data.IncomeList;
                rowsCount = rows.length;
              }
              // console.log("rows", res.data.IncomeList);
              this.setState({ ARD: null, dataLoadStatus: true }, () => {
                this.props.refreshReceiptList(rows, rowsCount);
                this.clearInfo();
              });
            } else {
              this.setState({ dataLoadStatus: true });
            }
          })
          .catch((error) => {
            this.props.updateProcessing(
              "error",
              "Unknown error occurred in delete deleteReceipt. " + error
            );
          });
      });
    } else {
      this.props.notifyProcessing();
      this.props.updateProcessing(
        "error",
        "There are no receipt records to delete."
      );
    }
  };

  setSaveBtnDisplay = () => {
    let isParamFound =
      this.props &&
      this.props.bint_incomesrno &&
      this.props.bint_incomesrno.length > 0;
    if (isParamFound !== true) {
      isParamFound = false;
    }
    let paramEditIncomeSrNo = 0;
    if (isParamFound) {
      paramEditIncomeSrNo = Number(this.props.bint_incomesrno);
      if (paramEditIncomeSrNo <= 0) {
        isParamFound = false;
      }
    }
    if (this.props.userPrivilege.Receipt == "M") {
      return "block";
    } else if (this.props.userPrivilege.Receipt == "R") {
      return "none";
    } else if (
      (this.props.userPrivilege.Receipt == "W" &&
        Number(this.state.formData.edit_incomesrno) > Number(0) &&
        isParamFound === false) ||
      (this.props.userPrivilege.Receipt == "W" &&
        Number(this.state.formData.edit_incomesrno) > Number(0) &&
        isParamFound === true &&
        Number(this.state.formData.edit_incomesrno) !==
          Number(paramEditIncomeSrNo)) ||
      (this.props.userPrivilege.Receipt == "W" &&
        Number(this.state.formData.edit_incomesrno) <= Number(0))
    ) {
      return "block";
    } else {
      return "none";
    }
  };

  getLedgerList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LedgerNameList",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchLedgerMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Ledger List Loaded");
        let LedgerGroup = res.data.LedgerNameList;
        let LedgerGroupList = getRowColData(LedgerGroup, "vac_groupname");
        this.setState(
          {
            LedgerGroup,
            LedgerGroupList,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getLedgerList.", error);
      });
  };

  onAddClickLedger = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<LedgerMaster showHeading={true} />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getLedgerList();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  /* setPaymentModeTableDataForSave = () => {
    if (this.state.rows.length > 0) {
      let rows = this.state.rows.map((row) => {
        console.log("row", row);
        if (row.chk_paymentmode === true) {
          return { ...row, dec_amount: Number(this.state.formData.txtAmount) };
        } else {
          return { ...row, dec_amount: '' };
        }
      })
      this.setState({
        rows
      })
    }
  } */

  setPaymentData = (rows) => {
    this.setState(
      {
        rows,
      },
      () => {
        // console.log("this.state.rows", this.state.rows);
      }
    );
  };

  setPaymentDataofReceipt = (checkRows, totalPaidAmt) => {
    let disableReceiptAmt = totalPaidAmt <= 0 ? false : true;

    // console.log("totalPaidAmt in start", totalPaidAmt);
    this.setState(
      {
        formData: { ...this.state.formData, txtAmount: totalPaidAmt },
        disableReceiptAmt,
        checkRows,
        // rows,
      },
      () => {
        if (totalPaidAmt == 0) {
          let rows = this.state.rows.map((row) => {
            if (row.chk_paymentmode === true) {
              return { ...row, dec_amount: "" };
            } else {
              return { ...row };
            }
          });
          this.setState({
            rows,
          });
          // console.log("this.state.rows", this.state.rows);
        }
        // console.log("this.state.rows", this.state.rows);
      }
    );
  };

  EnableReceiptAmt = (disableReceiptAmt) => {
    this.setState({
      formData: { ...this.state.formData, txtAmount: "" },
      disableReceiptAmt,
    });
  };

  // setReceiptAmt = (totalPaidAmt) => {
  //   console.log("totalPaidAmt set receipt", totalPaidAmt);
  //   this.setState({});
  // };

  openRichTextBox = (Heading, id, TxtChange) => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Set"
          fullscreenOnly={true}
          alertIcon=""
          alertTitle={Heading}
          alertMessage={
            <MoreInfoTextEditor
              TxtChange={TxtChange}
              Txtid={id}
              updateDetails={this.updateDetails}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  updateDetails = (id, Details) => {
    let txtRemark = this.state.formData.txtRemark,
      withoutText = Details.replace(/<[^>]*>/g, "").trim();

    if (withoutText.length <= 0) {
      Details = withoutText;
    }

    if (id === "Remark") {
      txtRemark = Details;
    }
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtRemark,
        },
      },
      () => {}
    );
  };

  hasHtmlFormatting = (text) => {
    if (!text) return false;

    const div = document.createElement("div");
    div.innerHTML = text;

    const cleanedText = text.replace(/<p>\s*<\/p>/gi, "");

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = cleanedText;

    const isVisiblyEmpty = tempDiv.textContent.trim() === "";
    const hasTags = /<[^>]+>/.test(cleanedText);

    const result = !isVisiblyEmpty && hasTags;

    return result;
  };

  //#endregion

  render() {
    // console.log("this.state.formData.txtAmount", this.state.formData.txtAmount);
    // console.log("this.state.rows", this.state.rows);
    // console.log("this.state.InvoiceData  render", this.state.InvoiceData);

    // console.log("this.state.checkRows", this.state.checkRows);
    // console.log("PendingInvoiceList render", this.state.PendingInvoiceList);
    // console.log(
    //   "InvoiceDataRemoveDuplicateInvoiceNo render",
    //   this.state.InvoiceDataRemoveDuplicateInvoiceNo
    // );
    // console.log(
    //   "InvoiceDataMeargPendingInvoiceList render",
    //   this.state.InvoiceDataMeargPendingInvoiceList
    // );

    if (Array.isArray(this.state.InvoiceData)) {
      this.state.InvoiceDataMeargPendingInvoiceList = [
        ...this.state.InvoiceData,
        ...this.state.PendingInvoiceList,
      ];
    } else {
      console.error("this.state.InvoiceData is not an array");
    }
    // console.log("Merged Array (Using spread operator)", InvoiceData);

    this.state.InvoiceDataRemoveDuplicateInvoiceNo =
      this.state.InvoiceDataMeargPendingInvoiceList.filter(
        (row, index, array) => {
          // console.log("row.bint_salessrno", row.bint_salessrno);
          return (
            array.findIndex((r) => r.bint_salessrno === row.bint_salessrno) ===
            index
          );
        }
      );

    // console.log(
    //   "this.state.InvoiceDataRemoveDuplicateInvoiceNo",
    //   this.state.InvoiceDataRemoveDuplicateInvoiceNo
    // );

    const displayReceiptNo =
      this.state.formData.edit_incomesrno &&
      Number(this.state.formData.edit_incomesrno) > 0
        ? undefined
        : "none";
    // console.log("this.state.LedgerGroup", this.state.LedgerGroup);

    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    let isSaveBtnDisplay = this.setSaveBtnDisplay();
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Receipt Entry</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item state display={displayReceiptNo}>
                <CtTxt
                  id="txtRecieptNo"
                  value={this.state.formData.txtRecieptNo}
                  label="Reciept No"
                  handleOnChange={this.handleOnChange}
                  width={100}
                  maxLength={10}
                  disabled={true}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpDate"
                  label="Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpDate}
                  value={this.state.formData.dtpDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  nextCtrlID={"cmbLedgerGroup"}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbLedgerGroup"
                  label="Ledger Group"
                  items={this.state.LedgerGroupList}
                  value={this.state.formData.cmbLedgerGroup}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={100}
                  colID="vac_groupname"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbLedger"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbLedger"
                  label="Ledger*"
                  items={this.state.LedgerGroup}
                  value={this.state.formData.cmbLedger}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={300}
                  maxLength={100}
                  dataFilter={
                    this.state.formData.cmbLedger !== this.props.cmbCustomer
                      ? [
                          {
                            filterColID: "vac_groupname",
                            value: this.state.formData.cmbLedgerGroup,
                          },
                        ]
                      : [] // Or provide a default behavior if needed
                  }
                  strictDataFilter={true}
                  colID="vac_ledgername"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtAmount"
                  onAddClick={this.onAddClickLedger}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxtAmt
                  id="txtAmount"
                  label="Receipt Amount*"
                  // disabled={true}
                  value={this.state.formData.txtAmount}
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  disabled={this.state.disableReceiptAmt}
                />
              </Grid>
              {/* <Grid item>
                <CtMultiLineText
                  id="txtRemark"
                  label="Remark"
                  value={this.state.formData.txtRemark}
                  handleOnChange={this.handleOnChange}
                  width={300}
                  maxLength={1000}
                />
              </Grid> */}
              {/* 
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <p
                  style={{
                    color: "#666666",
                    margin: "0",
                    padding: "0",
                    fontSize: "14px",
                  }}
                >
                  Remark
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "0",
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.formData.txtRemark,
                    }}
                    style={{ margin: "0", padding: "0" }}
                  />
                  <div style={{ margin: "0", padding: "0" }}>
                    <Edit
                      className={"child-button"}
                      style={{
                        border: "none",
                        cursor: "pointer",
                        // color: "#4687FF",
                      }}
                      onClick={() => {
                        this.openRichTextBox(
                          "Remark",
                          "Remark",
                          this.state.formData.txtRemark
                        );
                      }}
                    />
                  </div>
                </div>
              </Grid> */}
              <Grid item lg={8} md={8} sm={12} xs={12}>
                {!this.hasHtmlFormatting(this.state.formData.txtRemark) ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <CtMultiLineText
                        id="txtRemark"
                        label="Remark"
                        value={this.state.formData.txtRemark}
                        handleOnChange={this.handleOnChange}
                        width="100%"
                        maxLength={1000}
                        // onKeyDown={this.props.onKeyDown}
                      />
                    </div>
                    <Edit
                      className="child-button"
                      style={{
                        marginTop: "26px", // aligns with the input field
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "#1976d2",
                      }}
                      onClick={() => {
                        this.openRichTextBox(
                          "Remark",
                          "Remark",
                          this.state.formData.txtRemark
                        );
                      }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "4px",
                          color: "#666666",
                          fontSize: "14px",
                          fontWeight: 500,
                        }}
                      >
                        Remark
                      </label>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.formData.txtRemark,
                        }}
                        style={{
                          minHeight: "100px",
                          padding: "8px 12px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          background: "#f9f9f9",
                          fontSize: "14px",
                          color: "#333",
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                        }}
                      />
                    </div>
                    <Edit
                      className="child-button"
                      style={{
                        marginTop: "26px", // aligns with the top of remark box
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "#1976d2",
                      }}
                      onClick={() => {
                        this.openRichTextBox(
                          "Remark",
                          "Remark",
                          this.state.formData.txtRemark
                        );
                      }}
                    />
                  </div>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item marginLeft={3}>
            {this.state.formData.cmbLedgerGroup === "Customer" ? (
              <InvoiceListTable
                columns={this.state.columnsinvoice}
                rows={this.state.rowsinvoice}
                btnpaid={"SET INVOICE PAID"}
                btnunpaid={"SET INVOICE UNPAID"}
                Edit_SrNo={this.state.formData.edit_incomesrno}
                txtAmount={this.state.formData.txtAmount}
                PendingInvoiceList={this.state.PendingInvoiceList}
                setPaymentDataofReceipt={this.setPaymentDataofReceipt}
                EnableReceiptAmt={this.EnableReceiptAmt}
                disableReceiptAmt={this.state.disableReceiptAmt}
                InvoiceData={this.state.InvoiceDataRemoveDuplicateInvoiceNo}
                // setReceiptAmt={this.setReceiptAmt}
              />
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        <br />
        <PaymentModeTable
          DefaultEntrySettingList={this.state.defaultSetting}
          PaymentData={this.state.PaymentData}
          PaymentLedgerNameList={this.state.rows}
          Edit_SrNo={this.state.formData.edit_incomesrno}
          setPaymentData={this.setPaymentData}
          txtAmount={this.state.formData.txtAmount}
        />

        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          onKeyDown={this.props.onKeyDown}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          // handleOnActionClick={this.handleARDonActionClick}
          // actionList={this.state.actionList}
          // keyColumn={this.state.keyColumn}
          // handleOnSearchChange={this.handleOnSearchChange}
          // searchColumns={this.state.searchColumns}
          // searchData={this.state.searchData}
          // provideSearch={true}
          // handleOnNewEntryClick={this.handleOnNewEntryClick}
          handleOnRowDataChange={this.handleOnRowDataChange}
        // toolTipNewEntry='New Product Entry'
        /> */}
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item display={isSaveBtnDisplay}>
            <CtBtn
              label="Save"
              // onClick={this.SaveReciept}
              onClick={() => {
                this.trimFormData(() => {
                  this.SaveReciept();
                });
              }}
            />
          </Grid>
          <Grid item display={isSaveBtnDisplay}>
            <CtBtn
              label="Print"
              // onClick={this.openReceiptPrint}
              onClick={() => {
                this.trimFormData(() => {
                  this.SaveReciept(true);
                });
              }}
            />
          </Grid>
          <Grid item>
            <CtBtn label="New" onClick={this.clearInfo} variant="outlined" />
          </Grid>
          <Grid
            item
            display={
              this.props.userPrivilege.Receipt !== "M" ? "none" : "block"
            }
          >
            <CtBtn
              label="Delete"
              onClick={this.onDeleteClick}
              disabled={
                Number(this.state.formData.edit_incomesrno) > 0 ? false : true
              }
            />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(ReceiptEntry))));
